import clsx from 'clsx'

export const LoadingObjectType = {
  TEXT: 'text',
  TEXT_SHORT: 'text-short',
  INPUT_THIN: 'input-thin',
  INPUT: 'input',
  BUTTON: 'button',
  BUTTON_LONG: 'button-long',
  BUTTON_BIG: 'button-big',
  THUMBNAIL_BIG: 'thumbnail-big',
  THUMBNAIL_MIDDLE: 'thumbnail-middle',
  THUMBNAIL_SMALL: 'thumbnail-small',
  THUMBNAIL_MICRO: 'thumbnail-micro',
  LINE: 'line',
  TAB: 'tab'
} as const

export type LoadingObjectType = (typeof LoadingObjectType)[keyof typeof LoadingObjectType]

interface Props {
  type?: LoadingObjectType
  color?: 'default' | 'secondary'
}

const LoadingObject = ({ color = 'default', type = LoadingObjectType.TEXT }: Props) => {
  const objectClass =
    type == LoadingObjectType.TEXT
      ? 'h-2 w-full rounded-full'
      : type == LoadingObjectType.TEXT_SHORT
        ? 'h-2 w-2/3 rounded-full'
        : type == LoadingObjectType.INPUT_THIN
          ? 'h-4 w-40 rounded'
          : type == LoadingObjectType.INPUT
            ? 'h-6 w-40 rounded'
            : type == LoadingObjectType.BUTTON
              ? 'h-8 w-40 rounded'
              : type == LoadingObjectType.BUTTON_LONG
                ? 'h-8 min-w-[160px]	max-w-[400px] w-full rounded'
                : type == LoadingObjectType.BUTTON_BIG
                  ? 'h-[44px] w-40 rounded'
                  : type == LoadingObjectType.THUMBNAIL_BIG
                    ? 'h-20 w-20 rounded'
                    : type == LoadingObjectType.THUMBNAIL_MIDDLE
                      ? 'h-16 w-16 rounded'
                      : type == LoadingObjectType.THUMBNAIL_SMALL
                        ? 'h-10 w-10 rounded'
                        : type == LoadingObjectType.THUMBNAIL_MICRO
                          ? 'h-4 w-4 rounded'
                          : type == LoadingObjectType.LINE
                            ? 'h-0.5 w-full'
                            : type == LoadingObjectType.TAB
                              ? 'h-3 w-20 rounded-full'
                              : ''

  const colorClass = color == 'secondary' ? 'bg-fill-disabled-on-bg-fill' : 'bg-fill-tertiary'
  const beforeColorClass =
    color == 'secondary'
      ? 'before:to-shine-navi-to before:from-shine-navi-from'
      : 'before:to-shine-to before:from-shine-from'

  return (
    <div
      className={clsx(
        colorClass,
        'relative overflow-hidden before:absolute before:top-0 before:-left-3/4 before:h-full before:w-1/2 before:skew-x-[-25deg] before:content-[""]',
        'before:animate-shine before:bg-linear-to-r',
        objectClass,
        beforeColorClass
      )}
    />
  )
}

export default LoadingObject
